import request from '@/axios/axios'

// 产品列表
export function productList(query) {
  return request({
    url: '/device/v1/product/page',
    method: 'get',
    params: query
  })
}

// 删除产品
export function detele(query) {
  return request({
    url: '/device/v1/product/delete',
    method: 'post',
    data: query
  })
}


// 同步开发环境数据到测试/生产环境
export function syncInfo(query) {
  return request({
    url: '/device/v1/product/remote/sync/info',
    method: 'post',
    data: query
  })
}

